import React from "react";
import { Row, Col } from "reactstrap";
import DesignCard from "../DesignCard";
import get from "lodash/get";

const _ = { get };

const BranchReportsDetailPage = ({ rowData, elements }) => {
  return (
    <React.Fragment>
      {rowData ? (
        <div className="hideSearch my-3 px-3">
          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "branchReportsDetailListingElement.branchCodeElement",
                  "Branch Code"
                )}
                titleName={rowData.branchCode}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "branchReportsDetailListingElement.branchNameElement",
                  "Branch Name"
                )}
                titleName={rowData.branchName}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "branchReportsDetailListingElement.branchCountryElement",
                  "Branch Country"
                )}
                titleName={rowData.country}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "branchReportsDetailListingElement.branchStateElement",
                  "Branch State"
                )}
                titleName={rowData.state}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "branchReportsDetailListingElement.branchCityElement",
                  "Branch City"
                )}
                titleName={rowData.city}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "branchReportsDetailListingElement.branchIdElement",
                  "Branch Id"
                )}
                titleName={rowData.branchId}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "branchReportsDetailListingElement.branchStatusElement",
                  "Branch Status"
                )}
                titleName={rowData.branchStatus}
              />
            </Col>
          </Row>
        </div>
      ) : (
        <h5 className="text-center font-weight-bold">
          {_.get(
            elements,
            "branchReportsDetailListingElement.noUserFoundElement",
            "No user found"
          )}
        </h5>
      )}
    </React.Fragment>
  );
};

export default BranchReportsDetailPage;
